"use client"

import "./AboutPage.css"

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="about-header">
        <h2 className="section-title">
          <span className="title-icon">ℹ️</span>
          About bioForge
        </h2>
        <p className="section-subtitle">Evolution Warfare - Command humanity's future across hostile worlds</p>
      </div>

      <div className="about-content">
        <div className="about-section">
          <h3 className="about-section-title">🧬 What is bioForge?</h3>
          <p className="about-text">
            bioForge is an evolution simulation game where you command humanity's survival and adaptation across hostile
            alien worlds. Using real NASA data and cutting-edge AI, experience the ultimate challenge of species
            survival in the cosmos.
          </p>
        </div>

        <div className="about-section">
          <h3 className="about-section-title">🚀 Key Features</h3>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">🌍</span>
              <h4>Real NASA Data</h4>
              <p>Live integration with NASA APIs for authentic space conditions</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🧬</span>
              <h4>Evolution Engine</h4>
              <p>Advanced genetic algorithms simulate realistic evolution</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">⚔️</span>
              <h4>Multiplayer Raids</h4>
              <p>Strategic resource raids and colony management</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🤖</span>
              <h4>AI-Powered Laws</h4>
              <p>Create custom laws with AI assistance</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🌌</span>
              <h4>Multiple Planets</h4>
              <p>Unique challenges and resources on each world</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">📡</span>
              <h4>Real-Time Events</h4>
              <p>Dynamic storytelling based on real-world space events</p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h3 className="about-section-title">🌍 Real-World Integration</h3>
          <p className="about-text">
            bioForge connects to live NASA feeds, government policy databases, and space weather monitoring systems to
            create an authentic simulation experience. Your colonies face real solar storms, dust storms on Mars, and
            policy changes that affect space exploration.
          </p>
        </div>

        <div className="about-section">
          <h3 className="about-section-title">🔬 Technology Stack</h3>
          <div className="tech-grid">
            <div className="tech-item">
              <span className="tech-icon">⚛️</span>
              <span>React & Next.js</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">🗄️</span>
              <span>Supabase Database</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">🤖</span>
              <span>OpenAI GPT</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">🚀</span>
              <span>NASA APIs</span>
            </div>
            <div className="tech-item">
              <span className="tech-icon">🐍</span>
              <span>Python Evolution Engine</span>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h3 className="about-section-title">📞 Contact & Support</h3>
          <p className="about-text">
            For support, feedback, or bug reports, please contact our development team. We're constantly improving
            bioForge based on player feedback and real-world scientific discoveries.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AboutPage

